import React from 'react';
import { useSpring, config, animated } from 'react-spring';
import Profile from '../../components/Profile';

function Content({ picture, ...props }) {
  const zoomStyles = useSpring({
    config: { ...config.wobbly },
    from: { scale: 0 },
    to: { scale: 1 },
  });

  const zoomStylesD1 = useSpring({
    config: { ...config.wobbly },
    from: { scale: 0 },
    to: { scale: 1 },
    delay: 100,
  });

  const zoomStylesD2 = useSpring({
    config: { ...config.wobbly },
    from: { scale: 0 },
    to: { scale: 1 },
    delay: 200,
  });

  const zoomStylesD3 = useSpring({
    config: { ...config.wobbly },
    from: { scale: 0 },
    to: { scale: 1 },
    delay: 300,
  });

  return (
    <div className="container-lg" {...props}>
      <div className="text-center">
        <div className="d-none d-md-block mx-md-5">
          <animated.div
            className="mx-auto"
            style={{ position: 'relative', height: '200px', ...zoomStylesD3 }}
          >
            {!!picture && <Profile src={picture} alt="Dickson Palomeras" />}
          </animated.div>
        </div>
        <div className="my-3 m-md-5">
          <animated.span
            className="badge rounded-pill mb-3"
            style={{ background: 'var(--bs-teal)', ...zoomStyles }}
          >
            Web Developer
          </animated.span>
          <animated.h1 className="display-6 mb-3" style={{ ...zoomStylesD1 }}>
            Talk is cheap.
            <br />
            Show me the code
          </animated.h1>
          <animated.div className="mb-3" style={{ ...zoomStylesD2 }}>
            <small className="text-gray">
              I design and code beautifully simple things,
              <br />
              and I love what I do.
            </small>
          </animated.div>
          <animated.a
            href="#portfolio"
            className="btn btn-outline-light btn-lg mt-md-5 px-4"
            style={{ fontWeight: 700, letterSpacing: '0.1em', ...zoomStylesD3 }}
          >
            My Projects
          </animated.a>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Content);
